export const blockAttributesMap = {
    color: 'blockColor',
    fontSize: 'blockFontSize',
    fontFamily: 'blockFontFamily',
    lineHeight: 'blockLineHeight',
    letterspacing: 'blockLetterspacing',
    casing: 'blockCasing',
    fontWeight: 'blockFontWeight',
    fontStyle: 'blockFontStyle',
    textDecoration: 'blockTextDecoration',
    strokeColor: 'blockStrokeColor',
    strokeOverprints: 'blockStrokeOverprints',
    strokeThickness: 'blockStrokeThickness',
    strokePosition: 'blockStrokePosition',
    overprints: 'blockOverprints',
};

export const blockAttributesMapReversed = Object.entries(blockAttributesMap).reduce((dict, [value, key]) => {
    // eslint-disable-next-line no-param-reassign
    dict[key] = value;
    return dict;
}, {});

